export default "__VITE_ASSET__j7VukgyA__"